<template>
  <v-alert text dense border="left" class="ma-1" :type="type">
    <v-row no-gutters>
      <!-- TODO Title -->
      <v-col cols="12">
        <div class="title text text-uppercase">{{ item.title }}</div>
      </v-col>

      <!-- TODO Read/Unread -->
      <!-- <v-col cols="4">
        <v-btn small color="success" block outlined>อ่าน</v-btn>
      </v-col> -->

      <!-- TODO Description -->
      <v-col cols="12">
        <div class="message text">{{ item.message }}</div>
      </v-col>

      <!-- TODO Create By -->
      <v-col cols="12">
        <div class="createby text">โดย : {{ item.name }}</div>
      </v-col>

      <!-- TODO Create Date -->
      <v-col cols="12">
        <div class="createdate text">{{ item.create_date | moment }}</div>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'success'
    },
    color: {
      type: String,
      default: 'success'
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size: 10px;
$line-height: 3;
$lines-to-show: 1;

.text.title {
  font-family: "Kanit", sans-serif !important;
  font-size: 16px;
  font-weight: 600;
  //   background: red;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: normal;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.text.message {
  font-size: 14px;
  font-weight: 300;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--v-tprimary-base);
  //   background: green;
}

.createby {
  font-size: 12px;
  font-weight: 300;
  color: var(--v-tprimary-base);
}

.createdate {
  font-size: 11px;
  font-weight: 300;
  line-height: 2.5em;
}
</style>
